import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { SidePanelPages } from 'src/_models/panels';
import { SidePanelService } from 'src/app/components/panels/side-panel/side-panel.service';

@Component({
  selector: 'app-side-panel-title',
  templateUrl: './side-panel-title.component.html',
  styleUrl: './side-panel-title.component.css'
})
export class SidePanelTitleComponent implements OnInit, OnDestroy {

  subscriptions: Subscription[] = [];

  page: string = SidePanelPages.DEFAULT;
  sidePanelPages = SidePanelPages;

  constructor(
    private sidePanel: SidePanelService
  ) {  }

  ngOnInit() {
    this.pageHasChanged();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe())
  }

  pageHasChanged() {
    const pageOnChangeEvent = this.sidePanel.onPageChange.subscribe({
      next: (data) => {
        this.page = data;
      }
    });
    this.subscriptions.push(pageOnChangeEvent);
  }
  
}
